//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            invoices: [],
            selectedInvoices: [],
            details: false,
            checkDate: moment().format("MM/DD/YYYY"),
            period: moment(),
            description: '',
            printer: 'Madera',
            payment: {},
            sortKey: null,
            sortOrder: 'ASC'
        };
    },


    methods: {
        selectAll: function selectAll() {
            var _this = this;

            this.invoices.map(function (invoice) {
                _this.clickInvoice(invoice);
            });
        },
        clickInvoice: function clickInvoice(invoice) {

            var found = this.selectedInvoices.findIndex(function (inv) {
                return invoice.id === inv.id;
            });

            if (found < 0) {
                this.selectedInvoices.push(invoice);
            } else {
                this.selectedInvoices.splice(found, 1);
            }
        },
        invoiceStatus: function invoiceStatus(invoice) {
            return this.selectedInvoices.find(function (inv) {
                return invoice.id === inv.id;
            }) ? 'selected' : '';
        },
        save: function save() {
            var _this2 = this;

            this.payment.description = this.description;
            this.payment.printer = this.printer;
            this.payment.check_date = this.checkDate;
            this.payment.check_period = this.period;
            this.payment.invoices = this.selectedInvoices;
            axios.post('/prototype/accounting/accounts-payable/payments', this.payment).then(function (response) {
                Event.$emit('refresh-payments');
                Event.$emit('close-full-modal');
                _this2.$snotify.success('The payment was saved');
            });
        },
        APAddPayment: function APAddPayment() {
            var $el = this;

            Object.assign(this.$data, this.$options.data());
            $el.$children[0].$data.showModal = true;
            $el.invoices = [];
            axios.post('/prototype/accounting/accounts-payable/invoice/unpaid').then(function (response) {
                $el.invoices = response.data;
                $el.invoices.filter(function (item) {
                    return item.status !== 'Voided';
                });
                $el.loading = false;
            });
        },
        sortBy: function sortBy(key) {
            var _this3 = this;

            var forceNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


            if (key === this.sortKey) {
                this.sortOrder == 'ASC' ? this.sortOrder = 'DESC' : this.sortOrder = 'ASC';
            } else {
                this.sortKey = key;
                this.sortOrder = 'ASC';
            }

            var prop = this.sortKey.split('.');
            var len = prop.length;
            var data = this.invoices.slice().sort(function (a, b) {
                var i = 0;
                while (i < len) {

                    // These two checks are for when the object is missing from a record
                    if (a[prop[i]] === null) {
                        a = '';
                        break;
                    }

                    if (b[prop[i]] === null) {
                        b = '';
                        break;
                    }

                    a = a[prop[i]];
                    b = b[prop[i]];
                    i++;
                }

                //sort numerics like Unit Number
                a = forceNumber ? Number.parseFloat(a) : a;
                b = forceNumber ? Number.parseFloat(b) : b;

                return (a === b ? 0 : a > b ? 1 : -1) * (_this3.sortOrder === 'ASC' ? 1 : -1);
            });
            this.invoices = data;
        }
    },

    computed: {
        total: function total() {
            return this.invoices.reduce(function (sum, item) {
                return sum + parseFloat(item.amount);
            }, 0).toFixed(2);
        },
        totalSelected: function totalSelected() {
            return this.selectedInvoices.reduce(function (sum, item) {
                return sum + parseFloat(item.amount);
            }, 0).toFixed(2);
        }
    },
    created: function created() {
        Event.$on('ap-add-payment', this.APAddPayment);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('ap-add-payment');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/payments/AddPayment.vue
// module id = QeDQ
// module chunks = 0 1